module.exports = __webpack_public_path__ + "static/media/page02.d1efebd4.jpg";